__turbopack_context__.v({
  "helios-testimonial-carousel__byline": "KbzZJG_helios-testimonial-carousel__byline",
  "helios-testimonial-carousel__byline-detail": "KbzZJG_helios-testimonial-carousel__byline-detail",
  "helios-testimonial-carousel__panel": "KbzZJG_helios-testimonial-carousel__panel",
  "helios-testimonial-carousel__photo": "KbzZJG_helios-testimonial-carousel__photo",
  "helios-testimonial-carousel__quote": "KbzZJG_helios-testimonial-carousel__quote",
  "helios-testimonial-carousel__text": "KbzZJG_helios-testimonial-carousel__text",
});
